import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import "./styles.css";
import { COLORS } from "../../../utils/colors";

export default function AgeVerificationModal({
  event,
  open,
  onConfirm,
  onCancel,
  ageRestriction,
}) {
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    if (isChecked) {
      setIsChecked(false); // Reset checkbox for next time
      onConfirm();
    }
  };

  const handleCancel = () => {
    setIsChecked(false); // Reset checkbox for next time
    onCancel();
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  return (
    <Dialog
      maxWidth="sm"
      open={open}
      aria-labelledby="age-verification-dialog-title"
      aria-describedby="age-verification-dialog-description"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <Paper style={{ backgroundColor: "white", padding: "20px" }}>
        <DialogTitle
          id="age-verification-dialog-title"
          style={{
            textAlign: "center",
            color: "#333",
            fontWeight: "bold",
            fontSize: "1.5rem",
            paddingBottom: "16px",
          }}
        >
          Age Verification Required
        </DialogTitle>
        <DialogContent style={{ textAlign: "center", padding: "0 20px" }}>
          <Typography
            variant="body2"
            style={{
              color: "#333",
              marginBottom: "16px",
              fontSize: "0.9rem",
              textAlign: "left",
            }}
          >
            *You must be {ageRestriction.includes("21") ? "21" : "18"} years of
            age or older to use Uvenu
          </Typography>

          <FormControlLabel
            sx={{ display: "flex", justifyContent: "flex-start", alignItems:"center !important" }}
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                color="primary"
              />
            }
            label={
              <Typography variant="body2" style={{ fontSize: "0.9rem" }}>
                I acknowledge that I am at least{" "}
                {ageRestriction.includes("21") ? "21" : "18"} years of age or
                older
              </Typography>
            }
            style={{ alignItems: "flex-start", marginBottom: "16px" }}
          />
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            gap: "12px",
            padding: "0 20px 20px",
          }}
        >
          <Button
            onClick={handleCancel}
            variant="contained"
            style={{
              color: COLORS.textHeader,
              backgroundColor:
                event && event.brandingBackgroundColor
                  ? event.brandingBackgroundColor
                  : COLORS.primary,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            disabled={!isChecked}
            style={{
              color: COLORS.textHeader,
              backgroundColor:
                event && event.brandingBackgroundColor
                  ? event.brandingBackgroundColor
                  : COLORS.primary,
              textTransform: "none",
              opacity: !isChecked ? 0.5 : 1,
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  );
}
